import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {
  userActivity$: Observable<Event>;

  constructor(private ngZone: NgZone) {
    this.ngZone.runOutsideAngular(() => {
      this.userActivity$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'scroll'),
        fromEvent(document, 'click'),
        fromEvent(document, 'touchstart')
      );
    });
  }
}
